import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import AutocodeCheckBox from '../../ACShared/AutocodeCheckBox';
import AddNewButton from '../../../../images/Autocode/definitionAddNewButton.svg';
import { useACProjectContext } from '../../ACContext/ACDefinitionContext';
import { useACEditContext } from '../../ACContext/ACEditContext';
import { useACSelectionBoxContext } from '../../ACContext/ACSelectionBoxContext';
import AutocodeSelectionAction from '../../AutocodeSelectionBox/AutocodeSelectionActions';
import TargetDefinationMenu from '../AutocodeDefinationMenu/TargetDefinationMenu';
import { AC_PERSONAL_FOLDER_SCOPE } from '../../AutocodeConstants';
import ACDefinitionFolderDeleteModal from '../ACDefinitionFolderDeleteModal';
import { deleteDefinitions } from '../../../../actions/definitionActions';

const TargetDefinitionTableHeader = ({
  allDefinitionTarget,
  selectDefination,
  selectedFolder,
  canAddNewDefinitions,
  selectedWeightType,
}) => {
  const { defDataPoints, moduleStudy, activeAccountId } = useACProjectContext();
  const dispatch = useDispatch();
  const [popUp, setPopUp] = useState(false);

  const {
    setbackToDef,
    seteditFolderDetails,
    setcreateDefMode,
  } = useACEditContext();

  const acSelContext = useACSelectionBoxContext();
  const { removeAllNodes, setSelectionBoxDefinitionNodes } = AutocodeSelectionAction(
    acSelContext.state,
    acSelContext.dispatch
  );

  let isChecked = false;
  const enableTargetDefList = allDefinitionTarget.filter(item => item.display);
  const activeTargetCheck = enableTargetDefList.filter(item => item.checkState);
  if (
    enableTargetDefList.length !== 0 &&
    enableTargetDefList.length === activeTargetCheck.length
  ) {
    isChecked = true;
  }

  const _handleSelectAll = checkState => {
    selectDefination(checkState, allDefinitionTarget, true);
    isChecked = true;
  };

  const handleAddNewDefClicked = () => {
    removeAllNodes();
    setcreateDefMode(true);
    setbackToDef(false);
    seteditFolderDetails([{ selectedFolder: selectedFolder.selectedFolder }]);
    acSelContext.state.setTabsIndex(0);
    setSelectionBoxDefinitionNodes(acSelContext.state.rootNode);
  };

  const selectedData = allDefinitionTarget.filter(i => i.checkState);

  const _onDelete = () => {
    setPopUp(true);
  };

  const deleteDefinitionsData = defDelete => {
    defDelete.forEach(item => {
      const { expressionId, ovDefinitionId } = item;
      const ssid = moduleStudy.ss === 'SIMMONS' ? 1 : 2;
      const accountId = activeAccountId;
      const definitionFolderId = ovDefinitionId;

      dispatch(
        deleteDefinitions({
          ssid,
          accountId,
          expressionId,
          definitionFolderId,
          moduleStudy,
          selectedWeightType,
        })
      );
    });
  };

  return (
    <div
      className="ac--def--table__head"
      data-test="TargetDefinitionTableHeader"
    >
      <div className="ac--def--table__col " style={{ marginLeft: '8px' }}>
        <AutocodeCheckBox
          onChange={_handleSelectAll}
          id="ct_select_all"
          isChecked={isChecked}
          data={{ all: true }}
          label="Definitions"
          disable={!enableTargetDefList.length}
        />
      </div>
      {canAddNewDefinitions && defDataPoints.length < 2 && (
        <img
          className="row pull-right"
          src={AddNewButton}
          alt="add new"
          title="Add New Definiton"
          onClick={handleAddNewDefClicked}
          style={{
            cursor: 'pointer',
            paddingRight: '8px',
            marginRight: '0px',
          }}
        />
      )}
      {canAddNewDefinitions &&
        defDataPoints.length > 1 &&
        selectedFolder &&
        selectedFolder.selectedFolder &&
        (selectedFolder.selectedFolder.scope ===
          AC_PERSONAL_FOLDER_SCOPE.value1 ||
          selectedFolder.selectedFolder.scope ===
            AC_PERSONAL_FOLDER_SCOPE.value2) && (
          <span
            className="row pull-right"
            style={{
              cursor: 'pointer',
              paddingRight: '8px',
              marginRight: '0px',
            }}
          >
            {selectedData.length > 1 && (
              <TargetDefinationMenu
                item={selectedFolder}
                fill="black"
                onDelete={_onDelete}
              />
            )}
          </span>
        )}
      {popUp && (
        <ACDefinitionFolderDeleteModal
          folder={selectedData}
          show={selectedData.length > 1}
          closeHandler={() => setPopUp(false)}
          deleteHandler={() => {
            deleteDefinitionsData(selectedData);
            setPopUp(false);
          }}
        />
      )}
    </div>
  );
};

TargetDefinitionTableHeader.propTypes = {
  allDefinitionTarget: PropTypes.arrayOf(PropTypes.shape({})),
  selectDefination: PropTypes.func,
  selectedFolder: PropTypes.shape({
    selectedFolder: PropTypes.shape({
      scope: PropTypes.number,
    }),
  }),
  canAddNewDefinitions: PropTypes.bool,
  selectedWeightType: PropTypes.shape({}),
};

export default TargetDefinitionTableHeader;
